/**
 * Triggers a browser "Save As" for an in-memory blob, e.g. a file fetched
 * via HttpClient with `responseType: 'blob'`. The object URL is revoked
 * immediately after the click, since the browser has already read it by
 * then and holding onto it would just leak memory.
 * @param blob
 * @param filename
 */
export function saveBlobAsFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
